import type React from "react";
import { useEffect, useRef } from "react";

import { SidebarInset } from "@/components/ui/sidebar";

export function MainLayout({
  children,
  sidebar,
}: {
  children: React.ReactNode;
  sidebar: React.ReactNode;
}) {
  return (
    <div className="flex flex-1 overflow-hidden">
      {sidebar}
      <SidebarInset className="overflow-hidden h-svh">
        <RouterFocusManager />
        {children}
      </SidebarInset>
    </div>
  );
}

function RouterFocusManager() {
  const ref = useRef<HTMLDivElement>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: update with location change
  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, [location.pathname]);

  return <div ref={ref} tabIndex={-1} />;
}

export default MainLayout;
